
import arrayUtils from './arrayUtils';

type TGuid = () => string;
type TTimeout = (ms: number) => Promise<void>;
type TscrollTop = (yCoord?: number) => void;
type TRunFunction = (func: ((...args: any[]) => void) | null | undefined, arg?: any | any[]) => void;

const timeout: TTimeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const scrollTop: TscrollTop = (yCoord = 0) => window.scrollTo({top: yCoord});

const deepClone = (data: any) => JSON.parse(JSON.stringify(data));

const debounce = (func: (...args: any[]) => any, delay: number) => {
    let timerId: ReturnType<typeof setTimeout>;

    return (...args: any) => {
        clearTimeout(timerId);

        timerId = setTimeout(() => {
            func(...args);
        }, delay);
    };
};

const runFunction: TRunFunction = (func, arg) => {
    const args = arrayUtils.toArray(arg);

    if (typeof func === 'function') {
        return args ? func(...args) : func();
    }
};


export default {
    runFunction,
    scrollTop,
    timeout,
    deepClone,
    debounce,
};
